import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";

import Card from "./Card";

const StandardCards = ({ cards }) => {
    if (!cards?.length) {
        return null;
    }

    return (
        <Row className="h-100">
            {cards.map(card => (
                <Col className="my-2" key={card.link}>
                    <Card {...card} />
                </Col>
            ))}
        </Row>
    );
};

StandardCards.propTypes = {
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            customId: PropTypes.string,
            copy: PropTypes.shape({ raw: PropTypes.string }).isRequired,
            link: PropTypes.string,
            linkText: PropTypes.string,
        })
    ),
};

export default StandardCards;
